export const currencyKeys = {
  currencysList: () => ['currencyList'] as const,
}
